import { render, staticRenderFns } from "./Myacts.vue?vue&type=template&id=548535a9&scoped=true"
import script from "./Myacts.vue?vue&type=script&lang=js"
export * from "./Myacts.vue?vue&type=script&lang=js"
import style0 from "./Myacts.vue?vue&type=style&index=0&id=548535a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548535a9",
  null
  
)

export default component.exports